import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9f8e036"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://wasset.greedyai.com/sys/course/live.png",
  alt: "直播"
}, null, -1))
const _hoisted_3 = { class: "type" }
const _hoisted_4 = {
  key: 0,
  class: "not-started"
}
const _hoisted_5 = {
  key: 1,
  class: "not-started"
}
const _hoisted_6 = {
  key: 2,
  class: "living"
}
const _hoisted_7 = {
  key: 3,
  class: "living"
}
const _hoisted_8 = {
  key: 4,
  class: "finished"
}
const _hoisted_9 = { class: "info" }
const _hoisted_10 = {
  key: 0,
  class: "time"
}
const _hoisted_11 = {
  key: 1,
  class: "teacher"
}
const _hoisted_12 = { class: "extra" }
const _hoisted_13 = { class: "desc" }


import {Clock, User} from "@element-plus/icons";
import {CoursePlanPartVO} from "@/apis/course";
import useDateConvert from "@/composables/useDateConvert";
import usePartConvert from "@/composables/usePartConvert";
import {fetchLiveUrl} from "@/apis/live";
import {ElMessage} from "element-plus";


// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleLive',
  props: {
    part: {}
  },
  setup(__props: any) {

const props = __props

const {convertDatetime} = useDateConvert()
const {convertPartType} = usePartConvert()

const handleWatchLive = async (liveId: number) => {
  const res = await fetchLiveUrl(liveId)
  if (res?.code === 200) {
    window.open(res.data.url)
  } else {
    ElMessage.error(res?.msg);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["live", (_ctx.part.courseLivePlan?.status==='READY' || _ctx.part.courseLivePlan?.status==='ING') && 'living-wrapper'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(convertPartType)(_ctx.part)), 1),
      _createTextVNode(" " + _toDisplayString(_ctx.part.partName) + " ", 1),
      (!(_ctx.part.courseLivePlan?.status))
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "待安排"))
        : (_ctx.part.courseLivePlan?.status==='NORMAL')
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "未开始"))
          : (_ctx.part.courseLivePlan?.status==='READY')
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "即将开始"))
            : (_ctx.part.courseLivePlan?.status==='ING')
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "正在直播"))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, "已结束")),
      (_ctx.part.courseLivePlan?.status==='READY' || _ctx.part.courseLivePlan?.status==='ING')
        ? (_openBlock(), _createElementBlock("button", {
            key: 5,
            class: "watch-live-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleWatchLive(_ctx.part.courseLivePlan.id)))
          }, "观看直播 "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.part.courseLivePlan?.openTime)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_unref(Clock), { class: "icon" }),
            _createTextVNode(" 直播时间：" + _toDisplayString(_unref(convertDatetime)(_ctx.part.courseLivePlan.openTime, "YYYY年MM月DD日 HH:mm:ss")), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.part.courseLivePlan?.teacher)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_unref(User), { class: "icon" }),
            _createTextVNode(" 主讲老师：" + _toDisplayString(_ctx.part.courseLivePlan.teacher || '未配置'), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("label", null, [
          _createTextVNode("预习资料："),
          _createElementVNode("span", null, _toDisplayString(_ctx.part.courseLivePlan?.previewMaterialsPages.length || 0), 1)
        ]),
        _createElementVNode("label", null, [
          _createTextVNode("讲师课件："),
          _createElementVNode("span", null, _toDisplayString(_ctx.part.courseLivePlan?.instructorCoursewarePages.length || 0), 1)
        ]),
        _createElementVNode("label", null, [
          _createTextVNode("拓展阅读："),
          _createElementVNode("span", null, _toDisplayString(_ctx.part.courseLivePlan?.extendedReadingPages.length || 0), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.part.partDesc), 1)
  ], 2))
}
}

})